import { useCallback, useContext } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import {
  createTipoContrato,
  getTipoContrato,
  getTipoContratoLists,
} from "../../../../repositories/qerpapi/erp/faturamento/TipoContratosRepository";
import MaskService from "../../../../utils/mask/maskService";
import Swal from "sweetalert2";
import { notify } from "../../../../utils/notify";
import { validNotNull } from "../../../../utils/validations";
import { TipoServicoContext } from "../contexts/TipoServicoContext";
import { updateTipoContrato } from "../../../../repositories/qerpapi/erp/faturamento/TipoContratosRepository";
import { useHistory } from "react-router-dom";
import { searchByCompany } from "../../../../repositories/qerpapi/erp/faturamento/ContratoModeloRepository";
import { getNbsList } from "../../../../repositories/qerpapi/v3/main/taxation/NbsRepository";

const useTipoServicoController = () => {
  const {
    description,
    serviceCityCode,
    pis,
    cofins,
    csll,
    irrf,
    inss,
    iss,
    redBcIss,
    issRet,
    uf,
    city,
    aliqRet,
    reduction,
    setWithholdingsErrors,
    tableWithholdings,
    setTableWithholdings,
    verificationPisCofinsCsll,
    verificationIrff,
    verificationInss,
    periodPisCofinsCsll,
    periodIrrf,
    periodInss,
    setErrorsSubmit,
    active,
    codeNfse,
    codeIbpt,
    cnae,
    verificationPisCofinsCsllMinValue,
    verificationInssMinValue,
    verificationIrffMinValue,
    setLoading,
    setListIbpt,
    setListUf,
    setListCities,
    setAliqRet,
    setReduction,
    setEditWithholdingsErrors,
    setActive,
    setDescription,
    setServiceCityCode,
    setCodeNfse,
    setCodeIbpt,
    setListCitiesByUf,
    setPis,
    setCofins,
    setCsll,
    setIrrf,
    setInss,
    setIss,
    setRedBcIss,
    setIssRet,
    setVerificationIrffMinValue,
    setVerificationInssMinValue,
    setVerificationPisCofinsCsll,
    setVerificationIrff,
    setVerificationInss,
    setPeriodPisCofinsCsll,
    setPeriodIrrf,
    setPeriodIndss,
    setUf,
    setCity,
    setCnae,
    setVerificationPisCofinsCsllMinValue,
    setDescriptionIbpt,
    companies,
    setCompanies,
    listVerification,
    listPeriod,
    serviceId,
    setServiceId,
    withheldSn,
    setWithheldSn,
    setWithhedlPisCofinsCsll,
    setWithheldIrrf,
    setWithheldInss,
    withheldPisCofinsCsll,
    withheldIrrf,
    withheldInss,
    additionalData,
    setAdditionalData,
    contractSelected,
    setContractSelected,
    setContractList,
    taxation,
    setTaxation,
    setSelectedNbs,
    selectedNbs,
  } = useContext(TipoServicoContext);
  const { push } = useHistory();
  const { queryParams } = useContext(QueryParamsContext);

  const rmd = (value, fixed = 2) => {
    return MaskService.removeMaskDecimal(value, fixed);
  };

  const mask = (value, fractionDigits = 2) => {
    return MaskService.toMask(
      "decimal",
      parseFloat(value || 0.0).toFixed(fractionDigits),
      fractionDigits
    );
  };

  const confirmDeleteItem = (index, listTable, setListTable) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja remover o item?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const copy = [...listTable];
        copy.splice(index, 1);

        //Reordenação dos Indexs
        copy.forEach((value, newIndex) => {
          value.index = newIndex;
        });
        setListTable(copy);
      }
    });
  };

  const handleSubmit = async (newRegister = false) => {
    const jsonValidMain = [
      {
        key: "description",
        value: description,
      },
      {
        key: "serviceCityCode",
        value: serviceCityCode,
      },
    ];

    const validateSubmit = rulesTaxationSubmit(validNotNull(jsonValidMain));

    setErrorsSubmit({
      ...validateSubmit.errorsValidation,
    });

    if (validateSubmit.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );

    const checks = companies.find((company) => company.check);

    if (!checks)
      return notify("Selecione ao menos uma empresa", true, "warning");

    const tipocontratosempresa = [];
    companies.forEach((e) => {
      if (e.check) {
        tipocontratosempresa.push({ idempresa: e.id });
      }
    });

    const tipocontratosissmunicipio = [];
    if (issRet) {
      tableWithholdings.forEach((withholding) => {
        tipocontratosissmunicipio.push({
          estado_id: withholding.tEstadoId,
          municipio_codigo: withholding.tMunicipioCodigo,
          porc_aliq_retencao: rmd(withholding.tAliquotaRetencao, 5),
          porc_reducao: rmd(withholding.tReducao),
          simples_nacional_retido: withholding.tRetemSn ? 1 : 0,
          tipo_taxacao: withholding.tTaxacao,
        });
      });
    }

    const body = {
      tipocontrato: {
        descricao: description,
        ativo: active ? "S" : "N",
        nfse_codigo: codeNfse,
        codigo_servico_municipio: serviceCityCode,
        cnae: cnae,
        codigo_ibpt: codeIbpt,
        porc_pis: rmd(pis),
        porc_cofins: rmd(cofins),
        porc_csll: rmd(csll),
        val_rec_pis_cofins_csll: rmd(verificationPisCofinsCsllMinValue),
        val_rec_irrf: rmd(verificationIrffMinValue),
        apuracao_pis_cofins_csll: verificationPisCofinsCsll?.value || "",
        periodo_pis_cofins_csll: periodPisCofinsCsll?.value || "",
        porc_irrf: rmd(irrf),
        apuracao_irrf: verificationIrff?.value || "",
        periodo_irrf: periodIrrf.value || "",
        porc_inss: rmd(inss),
        val_inss: rmd(verificationInssMinValue),
        apuracao_inss: verificationInss?.value || "",
        periodo_inss: periodInss?.value || "",
        porc_iss: rmd(iss, 5),
        porc_base_reducao_iss: rmd(redBcIss),
        iss_retido: issRet,
        simples_nacional_retido_pis_cofins_csll: withheldPisCofinsCsll ? 1 : 0,
        simples_nacional_retido_irrf: withheldIrrf ? 1 : 0,
        simples_nacional_retido_inss: withheldInss ? 1 : 0,
        tipocontratosempresa,
        tipocontratosissmunicipio,
        dados_adicionais: additionalData,
        contrato_modelo_id: contractSelected?.id ?? null,
        codigo_nbs: selectedNbs?.code || null,
      },
    };

    try {
      setLoading(true);

      let callback = {};

      if (serviceId) {
        callback = await updateTipoContrato({
          id: serviceId,
          empresa_cnpj: queryParams.empresa_cnpj,
          body,
        });
      } else {
        callback = await createTipoContrato({
          empresa_cnpj: queryParams.empresa_cnpj,
          body,
        });
      }

      if (!callback.success) return notify("Erro ao salvar Tipo de Serviço.");

      if (!newRegister) push("listagem");

      clearClassRegister();

      return notify(
        `Serviço ${serviceId ? `Atualizado` : `Cadastrado`}`,
        true,
        "success"
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const rulesTaxationSubmit = (validate) => {
    if (pis || cofins || csll) {
      if (!verificationPisCofinsCsll) {
        validate.errorsValidation.verificationPisCofinsCsll = true;
        validate.error = true;
      }

      if (!periodPisCofinsCsll) {
        validate.errorsValidation.periodPisCofinsCsll = true;
        validate.error = true;
      }
    }

    if (irrf) {
      if (!verificationIrff) {
        validate.errorsValidation.verificationIrff = true;
        validate.error = true;
      }

      if (!periodIrrf) {
        validate.errorsValidation.periodIrrf = true;
        validate.error = true;
      }
    }

    if (inss) {
      if (!verificationInss) {
        validate.errorsValidation.verificationInss = true;
        validate.error = true;
      }

      if (!periodInss) {
        validate.errorsValidation.periodInss = true;
        validate.error = true;
      }
    }

    return validate;
  };

  const addMunicipalWithholdings = () => {
    const copyMunicipalWithholdings = [...tableWithholdings];

    const jsonValidMunicipalWithholdings = [
      {
        key: "uf",
        value: uf,
      },
      {
        key: "city",
        value: city,
      },
      {
        key: "aliqRet",
        value: rmd(aliqRet, 5),
      },
      {
        key: "taxation",
        value: taxation,
      },
    ];

    const validateMunicipalWithholdings = validNotNull(
      jsonValidMunicipalWithholdings
    );

    setWithholdingsErrors({
      ...validateMunicipalWithholdings.errorsValidation,
    });

    if (validateMunicipalWithholdings.error)
      return notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );

    copyMunicipalWithholdings.push(
      createItemMunicipalWithholding({
        index: copyMunicipalWithholdings.length,
        tEstado: uf?.estado,
        tEstadoCodigo: uf?.codibge,
        tEstadoId: uf?.id,
        tMunicipio: city?.municipio,
        tMunicipioCodigo: city?.codigo,
        tAliquotaRetencao: aliqRet,
        tReducao: reduction,
        tRetemSn: withheldSn,
        tTaxacao: taxation.value,
      })
    );

    setTableWithholdings(copyMunicipalWithholdings);
    clearMunicipalWidthholding();
  };

  const editMunicipalWithholding = ({
    index,
    uf,
    city,
    aliqRet,
    reduction,
    withheldSn,
    taxation,
  }) => {
    const copyMunicipalWithholdings = [...tableWithholdings];

    const jsonValidEditMunicipalWithholdings = [
      {
        key: "uf",
        value: uf,
      },
      {
        key: "city",
        value: city,
      },
      {
        key: "aliqRet",
        value: rmd(aliqRet, 5),
      },
      {
        key: "taxation",
        value: taxation,
      },
    ];

    const validateEditMunicipalWithholdings = validNotNull(
      jsonValidEditMunicipalWithholdings
    );

    setEditWithholdingsErrors({
      ...validateEditMunicipalWithholdings.errorsValidation,
    });

    if (validateEditMunicipalWithholdings.error) {
      notify(
        "Verifique se os campos foram preenchidos corretamente.",
        true,
        "warning"
      );
      return false;
    }

    copyMunicipalWithholdings[index] = createItemMunicipalWithholding({
      index: index,
      tEstado: uf?.estado,
      tEstadoCodigo: uf?.codibge,
      tEstadoId: uf?.id,
      tMunicipio: city?.municipio,
      tMunicipioCodigo: city?.codigo,
      tAliquotaRetencao: aliqRet,
      tReducao: reduction,
      tRetemSn: withheldSn,
      tTaxacao: taxation.value,
    });

    setTableWithholdings(copyMunicipalWithholdings);
    return true;
  };

  const clearMunicipalWidthholding = () => {
    setAliqRet("0,00000");
    setReduction("0,00");
    setTaxation(null);
    setUf(null);
    setCity(null);
    setWithheldSn(false);
  };

  const handleCheckCompany = (companyId) => {
    const copyCheckCompanies = [...companies];
    const companyIndex = copyCheckCompanies.findIndex(
      (comp) => comp.id === companyId
    );

    copyCheckCompanies[companyIndex] = {
      ...copyCheckCompanies[companyIndex],
      check: !copyCheckCompanies[companyIndex].check,
    };

    if (!copyCheckCompanies.filter((e) => e.check).length)
      return notify("Ao menos uma empresa deve estar selecionada.");

    setCompanies(copyCheckCompanies);
  };

  const createItemMunicipalWithholding = ({
    index,
    tEstado,
    tEstadoCodigo,
    tEstadoId,
    tMunicipio,
    tMunicipioCodigo,
    tAliquotaRetencao,
    tReducao,
    tRetemSn,
    tTaxacao,
  }) => {
    return {
      index: index,
      tEstado: tEstado,
      tEstadoCodigo: tEstadoCodigo,
      tEstadoId: tEstadoId,
      tMunicipio: tMunicipio,
      tMunicipioCodigo: tMunicipioCodigo,
      tAliquotaRetencao: tAliquotaRetencao,
      tReducao: tReducao,
      tRetemSn: tRetemSn,
      tTaxacao: tTaxacao,
    };
  };

  const clearClassRegister = useCallback(() => {
    const defaultVerification = { label: "Data Emissão", value: "Emissão" };
    const defaultPeriod = { label: "Dia", value: "Dia" };

    setServiceId(null);
    setDescriptionIbpt("");
    setCnae("");
    setErrorsSubmit({});
    setActive(true);
    setDescription("");
    setServiceCityCode("");
    setCodeNfse("");
    setCodeIbpt("");
    setListIbpt([]);
    setListUf([]);
    setListCities([]);
    setListCitiesByUf([]);
    setPis("0,00");
    setCofins("0,00");
    setCsll("0,00");
    setIrrf("0,00");
    setInss("0,00");
    setIss("0,00");
    setRedBcIss("0,00");
    setIssRet(false);
    setVerificationIrffMinValue("0,00");
    setVerificationPisCofinsCsllMinValue("0,00");
    setVerificationInssMinValue("0,00");
    setVerificationPisCofinsCsll(defaultVerification);
    setVerificationIrff(defaultVerification);
    setVerificationInss(defaultVerification);
    setPeriodPisCofinsCsll(defaultPeriod);
    setPeriodIrrf(defaultPeriod);
    setPeriodIndss(defaultPeriod);
    setUf(null);
    setCity(null);
    setTaxation(null);
    setAliqRet("0,00000");
    setReduction("0,00");
    setTableWithholdings([]);
    setWithholdingsErrors({});
    setEditWithholdingsErrors({});
    setWithhedlPisCofinsCsll(false);
    setWithheldIrrf(false);
    setWithheldInss(false);
    setCompanies((current) => current.map((e) => ({ ...e, check: true })));
    setAdditionalData("");
    setContractSelected(null);
    setSelectedNbs(null);
  }, [
    setCompanies,
    setActive,
    setAliqRet,
    setCity,
    setCnae,
    setCodeIbpt,
    setCodeNfse,
    setCofins,
    setCsll,
    setDescription,
    setDescriptionIbpt,
    setEditWithholdingsErrors,
    setErrorsSubmit,
    setInss,
    setIrrf,
    setIss,
    setIssRet,
    setListCities,
    setListCitiesByUf,
    setListIbpt,
    setListUf,
    setPeriodIndss,
    setPeriodIrrf,
    setPeriodPisCofinsCsll,
    setPis,
    setRedBcIss,
    setReduction,
    setServiceCityCode,
    setServiceId,
    setTableWithholdings,
    setUf,
    setVerificationInss,
    setVerificationInssMinValue,
    setVerificationIrff,
    setVerificationIrffMinValue,
    setVerificationPisCofinsCsll,
    setVerificationPisCofinsCsllMinValue,
    setWithhedlPisCofinsCsll,
    setWithheldInss,
    setWithheldIrrf,
    setWithholdingsErrors,
    setAdditionalData,
    setContractSelected,
    setTaxation,
    setSelectedNbs,
  ]);

  const handleSelectedIbpt = (setOpen, selected) => {
    const item = selected[0];
    if (!item) return;

    setDescriptionIbpt(item?.descricao);
    setCodeIbpt(item?.codigo);

    setOpen(false);
  };

  const handleSetData = useCallback(
    async (id = null) => {
      if (!queryParams?.empresa_cnpj) return;

      // Limpo os campos sempre que entra na página
      clearClassRegister();

      try {
        setLoading(true);

        const viewCallback = await getTipoContratoLists({
          empresa_cnpj: queryParams.empresa_cnpj,
        });

        if (!viewCallback?.success)
          return notify("Ocorreu um erro ao buscar os dados.");

        const requestCompanies = viewCallback.data?.empresas || [];
        const requestListUf = viewCallback.data?.estados || [];
        const requestListCities = viewCallback.data?.municipios || [];
        setListUf(requestListUf);
        setListCities(requestListCities);

        let arrayContracts = [];
        const callbackContracts = await searchByCompany({
          empresa_cnpj: queryParams.empresa_cnpj,
          companyId: parseInt(queryParams.empresa_id),
          orderByColumn: "id",
        });

        if (callbackContracts.success) {
          arrayContracts = callbackContracts.data;
          setContractList(arrayContracts);
        }

        if (id) {
          const callback = await getTipoContrato({
            id: id,
            empresa_cnpj: queryParams.empresa_cnpj,
            include: "tipocontratosissmunicipio,tipocontratosempresa",
          });

          if (!callback?.success)
            return notify("Erro ao buscar dados do contrato");

          const servico = callback.data;
          const municipalWithholdings = [];
          const defaultVerification = {
            label: "Data Emissão",
            value: "Emissão",
          };
          const defaultPeriod = { label: "Dia", value: "Dia" };

          (servico?.tipocontratosissmunicipio || []).forEach((row, index) => {
            const state = requestListUf.find(
              (uf) => uf.id.toString() === row.estado_id.toString()
            );

            const city = requestListCities.find(
              (county) =>
                county.codigo.toString() === row.municipio_codigo.toString()
            );

            municipalWithholdings.push(
              createItemMunicipalWithholding({
                index: index,
                tEstado: state.estado,
                tEstadoCodigo: state.codibge,
                tEstadoId: row.estado_id.toString(),
                tMunicipio: city?.municipio || "",
                tMunicipioCodigo: row.municipio_codigo.toString(),
                tAliquotaRetencao: mask(row.porc_aliq_retencao, 5),
                tReducao: mask(row.porc_reducao),
                tRetemSn: row.simples_nacional_retido === 1,
                tTaxacao: row.tipo_taxacao || "None",
              })
            );
          });
          setServiceId(servico.id);
          setCnae(servico.cnae);
          setActive(servico.ativo === "S");
          setDescription(servico.descricao);
          setAdditionalData(servico.dados_adicionais);
          setServiceCityCode(servico.codigo_servico_municipio);
          setCodeNfse(servico.nfse_codigo);
          setCodeIbpt(servico.codigo_ibpt);
          setPis(mask(servico.porc_pis));
          setCofins(mask(servico.porc_cofins));
          setCsll(mask(servico.porc_csll));
          setIrrf(mask(servico.porc_irrf));
          setInss(mask(servico.porc_inss));
          setIss(MaskService.changeUStoBR(servico.porc_iss));
          setRedBcIss(mask(servico.porc_base_reducao_iss));
          setIssRet(servico.iss_retido ? true : false);
          setVerificationIrffMinValue(mask(servico.val_rec_irrf));
          setWithhedlPisCofinsCsll(
            servico.simples_nacional_retido_pis_cofins_csll === 1
          );
          setWithheldIrrf(servico.simples_nacional_retido_irrf === 1);
          setWithheldInss(servico.simples_nacional_retido_inss === 1);
          setVerificationPisCofinsCsllMinValue(
            mask(servico.val_rec_pis_cofins_csll)
          );
          setVerificationInssMinValue(mask(servico.val_inss));
          setVerificationPisCofinsCsll(
            listVerification.find(
              (verify) => verify.value === servico.apuracao_pis_cofins_csll
            ) || defaultVerification
          );
          setVerificationIrff(
            listVerification.find(
              (verify) => verify.value === servico.apuracao_irrf
            ) || defaultVerification
          );
          setVerificationInss(
            listVerification.find(
              (verify) => verify.value === servico.apuracao_inss
            ) || defaultVerification
          );
          setPeriodPisCofinsCsll(
            listPeriod.find(
              (period) => period.value === servico.periodo_pis_cofins_csll
            ) || defaultPeriod
          );
          setPeriodIrrf(
            listPeriod.find(
              (period) => period.value === servico.periodo_irrf
            ) || defaultPeriod
          );
          setPeriodIndss(
            listPeriod.find(
              (period) => period.value === servico.periodo_inss
            ) || defaultPeriod
          );
          setTableWithholdings(municipalWithholdings);
          setCompanies(
            requestCompanies.map((e) => ({
              ...e,
              check: (servico?.tipocontratosempresa || []).some(
                (comp) =>
                  comp.idempresa.toString() === e.id.toString() ||
                  requestCompanies.length === 1
              ),
            }))
          );
          const contratoModeloId = arrayContracts.find(
            (contract) => contract.id === servico?.contrato_modelo_id
          );
          setContractSelected(contratoModeloId);

          if (servico?.codigo_nbs) {
            const nbsListResponse = await getNbsList({
              filters: {
                code: `strict:${servico?.codigo_nbs}`,
              },
            });

            if (!nbsListResponse?.success)
              return notify("Erro ao buscar o NBS");

            setSelectedNbs(nbsListResponse?.data[0] || null);
          }
        } else {
          setCompanies(requestCompanies.map((e) => ({ ...e, check: true })));
          setContractSelected(
            arrayContracts.find((contract) => contract.id === 1)
          );
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
    [
      listPeriod,
      listVerification,
      queryParams.empresa_cnpj,
      queryParams.empresa_id,
      setLoading,
      setCnae,
      setActive,
      setDescription,
      setAdditionalData,
      setServiceCityCode,
      setCodeNfse,
      setCodeIbpt,
      setPis,
      setCofins,
      setCsll,
      setIrrf,
      setInss,
      setIss,
      setRedBcIss,
      setIssRet,
      setVerificationIrffMinValue,
      setVerificationPisCofinsCsllMinValue,
      setVerificationInssMinValue,
      setTableWithholdings,
      setPeriodPisCofinsCsll,
      setPeriodIrrf,
      setPeriodIndss,
      setVerificationPisCofinsCsll,
      setVerificationIrff,
      setVerificationInss,
      setServiceId,
      setWithhedlPisCofinsCsll,
      setWithheldIrrf,
      setWithheldInss,
      clearClassRegister,
      setCompanies,
      setListCities,
      setListUf,
      setContractList,
      setContractSelected,
      setSelectedNbs,
    ]
  );

  return {
    addMunicipalWithholdings,
    handleSubmit,
    handleCheckCompany,
    confirmDeleteItem,
    editMunicipalWithholding,
    clearClassRegister,
    handleSelectedIbpt,
    handleSetData,
  };
};

export default useTipoServicoController;
